<ng-container *ngIf="accessRoute">
  <h4>
    What is the maximum dimensions to access the site?
    <span class="fine-print trinidad">(Optional)</span>
  </h4>
  <p class="fine-print">Leave empty if your site and the roads to the site have no extra restrictions.</p>
  <div class="input-wrapper">
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxLength"
        type="number"
        class="text-field-rounded-left w-input"
        min="0"
        [formControl]="maxLength"
        [containerElement]="maxLengthError"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxLength">Max Length (FT)</label>
        </div>
      </div>
    </div>
    <div #maxLengthError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxWidth"
        type="number"
        class="text-field-rounded-left w-input"
        min="0"
        [formControl]="maxWidth"
        [containerElement]="maxWidthError"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxWidth">Max Width (FT)</label>
        </div>
      </div>
    </div>
    <div #maxWidthError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxHeight"
        type="number"
        class="text-field-rounded-left w-input"
        min="0"
        [formControl]="maxHeight"
        [containerElement]="maxHeightError"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxHeight">Max Height (FT)</label>
        </div>
      </div>
    </div>
    <div #maxHeightError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
  </div>
  <curbnturf-road-conditions [roadCondition]="roadCondition"> </curbnturf-road-conditions>
</ng-container>
